export const formatMobileNumber = (mobileNumber) => {
    const mobileSplits = mobileNumber.split("-");
    return {
        countryCode: mobileSplits.length > 1 ? mobileSplits[0] : "",
        phoneNumber: mobileSplits.length > 1 ? mobileSplits[1] : mobileSplits[0],
    };
};